import { fqa } from "./liquidInit"

export function magicDisable(element) {
  element.disabled = true
}

export function magicEnable(element) {
  element.disabled = false
}

export function disable(selector) {
  document.querySelectorAll(selector).forEach((element) => {
    console.warn("Disable ", element)
    element.disabled = true
  })
}

export function enable(selector) {
  document.querySelectorAll(selector).forEach((element) => {
    console.warn("Enable ", element)
    element.disabled = false
  })
}

export function toFraction(num) {
  if (num.toString() === "0") {
    return "0"
  }

  if (num < 1) {
    num = num.toString().substr(1)
  }

  return num
    .toString()
    .replace(".25", "¼")
    .replace(".5", "½")
    .replace(".75", "¾")
}

export function generateLineItemPropertyFromValue(productFractionalQuantity) {
  // Calculate fractional qty
  productFractionalQuantity = parseFloat(productFractionalQuantity)

  // Replace .5 .25 .75 with fractions
  const productFractionalQuantityFraction = toFraction(
    productFractionalQuantity
  )

  // Create Variable to hold the Product Cut Length Line Item Property
  let productCutLength = ""

  // if "Yard" quantity is less than 1
  // Creates property such as "3/4 of a yard"
  if (productFractionalQuantity < 1) {
    productCutLength +=
      productFractionalQuantityFraction +
      fqa.strings.separator_less_then_one +
      fqa.strings.unit_singular

    // if "Yard" quantity equals 1
    // Creates property for "1 Continuous Yard"
  } else if (productFractionalQuantity === 1) {
    productCutLength +=
      productFractionalQuantityFraction +
      fqa.strings.separator_more_then_one +
      fqa.strings.unit_singular

    // if "Yard" quantity is greater than 1
    // Creates property for "2 1/4 Continuous Yards"
  } else if (productFractionalQuantity > 1) {
    productCutLength +=
      productFractionalQuantityFraction +
      fqa.strings.separator_more_then_one +
      fqa.strings.unit_plural

    // Throw error Error if a quantity is invalid.
  } else {
    console.error("Error: quantity is invalid")
  }

  return productCutLength
}
